/**
 * «Configurar mis alertas con IA» — the way back to the onboarding's AI step
 * (Spain, `features.aiOnboardingReentry`, negative QA 22.10, C11).
 *
 * The onboarding sheet opens by itself at most once a day and three times in
 * all (`lib/onboarding-gate.ts`). Someone who closed it with ✕, or simply left
 * the page, had no way back to «¿Qué ofreces?»: 0 of 10 navigations in the QA
 * run brought it back, and nothing on screen offered it. This button asks the
 * sheet for its search step by hand (`requestOnboardingSearch`), which opens it
 * at once, past that gate — the gate stays what governs the sheet that opens
 * by itself.
 *
 * Only for a signed-in reader with NO saved search: the sheet's search step is
 * for creating the first one (it opens nothing for a reader who has one), and
 * a guest's way in is registration. Callers gate on the flag, so on UZ/KZ this
 * is never mounted.
 */
import { useQuery } from '@tanstack/react-query';
import { useLocale } from '../i18n/locale-context';
import { useAuthOptional } from '../lib/auth-context';
import { requestOnboardingSearch } from '../lib/onboarding-request';
import { listSavedSearches } from '../lib/saved-search-client';
import { AiSparkle, aiSecondaryClass } from './ai-search-cards';

export function AiOnboardingEntry({ className = '' }: { className?: string }) {
  const { t } = useLocale();
  const authed = useAuthOptional()?.status === 'authed';
  // The same key the sheet, the sidebar and the alerts page read — one request.
  const { data: searches } = useQuery({
    queryKey: ['saved-searches'],
    queryFn: listSavedSearches,
    enabled: authed,
  });
  // Unknown is not «none»: wait for the list rather than flash the button at a
  // reader who has searches.
  if (!authed || searches === undefined || searches.length > 0) return null;
  return (
    <button
      type="button"
      onClick={() => requestOnboardingSearch()}
      className={`${aiSecondaryClass} ${className}`}
    >
      <AiSparkle className="mr-1.5" />
      {t('aiOnboarding.reentry')}
    </button>
  );
}
